module.exports = __webpack_public_path__ + "static/ecc-72ae0d25667e73da377e2ac9efb88681.jpg";